<template>
  <div style="padding:0 24px;height: 100%;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$t('churukuliushuihuizong')" ref="yt" getUrl="/web/material/inventory/record/inventoryRecordSummery" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <!-- 交易单号 -->
          <el-form-item :label="$t('jiaoyidanhao')">
            <el-input v-model="yt.conditions.transactionNo"></el-input>
          </el-form-item>
          <!-- 交易类型 -->
          <el-form-item :label="$t('jiaoyileixing')">
            <yi_dictionary_select :type="'TRANSACTION_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <!-- 发生时间  时间区间查询条件 -->
          <el-form-item :label="$t('fashengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({startTime: begin(),endTime:end()})">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" :loading="exportLoading" @click="exportExcel()" type="primary">
          {{ $t('daochu') }}
        </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script lang="text/javascript">
import XLSX from 'xlsx';
export default {
  data() {
    return {
      columns: [
        {
          label: 'fashengshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'jiaoyileixing',
          prop: 'type',
          type: 'dictionary',
          key: 'TRANSACTION_TYPE'
        },
        {
          label: 'jiaoyidanhao',
          prop: 'transactionNo'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          show: false
        },
        {
          label: 'chanpinfenlei',
          prop: 'material.value',
          type: 'dictionary',
          key: 'GYLXCPFL'
        },
        {
          label: 'cangkubianma',
          prop: 'warehouse.code'
        },
        {
          label: 'cangkumingcheng',
          prop: 'warehouse.name'
        },
        {
          label: 'cangkudizhi',
          prop: 'warehouse.address'
        },
        {
          label: 'kuqubianma',
          prop: 'warehouseArea.code'
        },
        {
          label: 'kuqumingcheng',
          prop: 'warehouseArea.name'
        },
        {
          label: 'kuweibianma',
          prop: 'warehouseLocation.code'
        },
        {
          label: 'kuweimingcheng',
          prop: 'warehouseLocation.name'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'jiaoyishuliang',
          prop: 'transactionQuantity'
        },
        {
          label: 'caozuoqiankucun',
          prop: 'oldQuantity'
        },
        {
          label: 'caozuohoukucun',
          prop: 'newQuantity'
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name'
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomer.name'
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo'
        },
        {
          label: 'shengchanpicihao',
          prop: 'productionBatchNo'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: "beizhu",
          prop: "remark",
        },
      ],
      exportLoading: false,
      colorNoEnable: false,
    }
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt.conditions, 'startTime', this.begin());
      this.$set(this.yt.conditions, 'endTime', this.end());
      this.yt.get(1);
      this.getProductionConfig();
    }, 300);
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        let c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    //导出
    exportExcel() {
      this.exportLoading = true;
      //查询表格
      this.http.get('/web/material/inventory/record/inventoryRecordSummery?pageNum=1&pageSize=99999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = [this.$t('fashengshijian'),this.$t('caozuoren'),this.$t('jiaoyileixing'),this.$t('jiaoyidanhao'),this.$t('wuliaobianma'),
          this.$t('wuliaomingcheng'),this.$t('sehao'),this.$t('chanpinfenlei'),this.$t('cangkubianma'),this.$t('cangkumingcheng'),this.$t('cangkudizhi'),
          this.$t('kuqubianma'),this.$t('kuqumingcheng'),this.$t('kuweibianma'),this.$t('kuweimingcheng'),this.$t('danwei'),this.$t('jiaoyishuliang'),
          this.$t('caozuoqiankucun'),this.$t('caozuohoukucun'),this.$t('gongyingshangmingcheng'),this.$t('kehumingcheng'),this.$t('wuliaopicihao'),
          this.$t('shengchanpicihao'),this.$t('shengchangongdanhao'),this.$t('beizhu')];
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i]);
          tableData.push(dataArr);
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `出入库流水汇总_${this.dayjs().format('YYYYMMDDHHmmss')}.xlsx`);
      })
      .finally(() => {
        this.exportLoading = false;
      });
    },
    getTableDataArr(row) {
      let dataArr = [];
      dataArr[0] = row.createTime ? this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss') : '';
      dataArr[1] = row.createByObject ? row.createByObject.nickname : '';
      dataArr[2] = row.type && this.$store.state.dictJson['TRANSACTION_TYPE'] ? this.$t(this.$store.state.dictJson['TRANSACTION_TYPE'][row.type]) : '';
      dataArr[3] = row.transactionNo ? row.transactionNo : '';
      dataArr[4] = row.material ? row.material.code : '';
      dataArr[5] = row.material ? row.material.name : '';
      dataArr[6] = row.colorNo ? row.colorNo : '';
      dataArr[7] = row.material && this.$store.state.dictJson['GYLXCPFL'] ? this.$store.state.dictJson['GYLXCPFL'][row.material.value] : '';
      dataArr[8] = row.warehouse ? row.warehouse.code : '';
      dataArr[9] = row.warehouse ? row.warehouse.name : '';
      dataArr[10] = row.warehouse ? row.warehouse.address : '';
      dataArr[11] = row.warehouseArea ? row.warehouseArea.code : '';
      dataArr[12] = row.warehouseArea ? row.warehouseArea.name : '';
      dataArr[13] = row.warehouseLocation ? row.warehouseLocation.code : '';
      dataArr[14] = row.warehouseLocation ? row.warehouseLocation.name : '';
      dataArr[15] = row.unit ? row.unit : '';
      dataArr[16] = row.transactionQuantity ? row.transactionQuantity : '';
      dataArr[17] = row.oldQuantity ? row.oldQuantity : '';
      dataArr[18] = row.newQuantity ? row.newQuantity : '';
      dataArr[19] = row.supplier ? row.supplier.name : '';
      dataArr[20] = row.wmsCustomer ? row.wmsCustomer.name : '';
      dataArr[21] = row.materialBatchNo ? row.materialBatchNo : '';
      dataArr[22] = row.productionBatchNo ? row.productionBatchNo : '';
      dataArr[23] = row.woNo ? row.woNo : '';
      dataArr[24] = row.remark ? row.remark : '';
      return dataArr;
    },
    begin() {
      let date = new Date();
      let begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime();
      return begin;
    },
    end() {
      let date = new Date()
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let lastDay = new Date(year, month, 0).getDate();
      let end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime();
      return end;
    },
  },
}
</script>
<style lang="scss">

</style>